import { httpCreate } from './http';
const http = httpCreate('/srv/live-transcode-template');

export const capacityRate = {
	getRateWorkList(params) {
		return http.get('', { params });
	},
	addRateWork(workId, data) {
		return http.post(`/${workId}`, data);
	},
	updateRateWork(workId, data) {
		return http.put(`/${workId}`, data);
	},
	deleteRateWork(workId) {
		return http.delete(`/${workId}`);
	},
	// 获取当前直播间的码率
	getActivityRate(activityId) {
		return http.get(`/user/${activityId}`);
	},
	// 设置当前直播间的码率
	setActivityRate(activityId, data) {
		return http.put(`/user/${activityId}`, data);
	},
};
